import { ToDoListEntry } from 'modules/dashboard/types/widgets/widget.interfaces';

export const matchesSearchCriteria = (clientEntry: ToDoListEntry, searchTerm: string) => {
  const searchLower = searchTerm.toLowerCase();

  const nameMatch =
    clientEntry.clientName && clientEntry.clientName.toLowerCase().includes(searchLower);
  const planMatch =
    clientEntry.investmentNumber &&
    clientEntry.investmentNumber.toString().toLowerCase().includes(searchLower);

  return nameMatch || planMatch;
};

type StatusFilterRange = { min: number; max: number };

export const getToDoListStatusFilterRange = (selected: number[]): StatusFilterRange[] => {
  const minMap: Record<number, number> = { 7: 0, 30: 7, 60: 30 };
  const valueRanges: StatusFilterRange[] = [];

  if (selected.length === 0) {
    return valueRanges;
  }

  if (selected[0]) {
    let currentMin = minMap[selected[0]] ?? 0;
    let currentMax = selected[0];

    if (currentMin !== undefined && currentMax !== undefined) {
      for (let i = 1; i < selected.length; i++) {
        const prev = selected[i - 1];
        const curr = selected[i];

        if (curr !== undefined && prev !== undefined) {
          if (curr - prev === prev - (minMap[prev] ?? 0)) {
            currentMax = curr;
          } else {
            valueRanges.push({ min: currentMin, max: currentMax });
            currentMin = minMap[curr] ?? 0;
            currentMax = curr;
          }
        }
      }

      valueRanges.push({ min: currentMin, max: currentMax });
    }
  }

  return valueRanges;
};
